import { Routes } from '@angular/router';
import {authGuard} from "./core/auth/auth.guard";

export const routes: Routes = [
    { path: 'auth', loadComponent: () => import('./modules/auth/auth.component').then(m => m.AuthComponent) },
    { path: 'login', loadComponent: () => import('./modules/login/login.component').then(m => m.LoginComponent) },
    { path: 'recovery/:id', loadComponent: () => import('./modules/recovery/recovery.component').then(m => m.RecoveryComponent) },
    // { path: 'cadastro', loadComponent: () => import('./modules/register/register.component').then(m => m.RegisterComponent) },
    { path: 'primeiro-acesso-clinica/:id', loadComponent: () => import('./modules/create-password/create-password.component').then(m => m.CreatePasswordComponent) },
    { path: 'confirmar-email/:token', loadComponent: () => import('./modules/confirm-email/confirm-email.component').then(m => m.ConfirmEmailComponent) },
    { path: 'visualizador/:id', loadComponent: () => import('./modules/public-viewer/public-viewer.component').then(m => m.PublicViewerComponent) },
    { path: '', redirectTo: 'conta', pathMatch: 'full' },
    {
        path: 'conta',
        loadChildren: () => import('./layout/main/main.module').then(m => m.MainModule),
        canActivate: [authGuard]
    },
    {
        path: 'criar-conta',
        loadChildren: () => import('./modules/create-account-dentist/create-account-dentist.module').then(m => m.CreateAccountDentistModule)
    },
    { path: '**', redirectTo: 'login'}
];
